import { Directive } from '@angular/core';

@Directive({
    selector: '[ndtRightColumn]',
    host: { class: 'right-column' },
    standalone: false
})
export class RightColumnDirective {}
